const profile = [
  {
    title: 'Summary',
    descr: (
      <div>
        <p>What I achieved:</p>
        <ul>
          <li>
            <a
              href="https://lickoneyou.github.io/CV/#Projects"
              className="profileLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Created 𝟐𝟔 websites and applications
            </a>
            <img
              src="./images/icons/link.png"
              className="linkIcon"
              alt="linkIcon"
            />
          </li>
          <li>Created 𝟑 browser extensions</li>
          <li>
            <a
              href="https://github.com/bradtraversy/50projects50days"
              className="profileLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Completed 𝟓𝟎 course assignments 𝟓𝟎 𝐏𝐫𝐨𝐣𝐞𝐜𝐭𝐬 𝟓𝟎 𝐃𝐚𝐲𝐬
            </a>
            <img
              src="./images/icons/link.png"
              className="linkIcon"
              alt="linkIcon"
            />
          </li>
          <li>
            <a
              href="https://rs.school/"
              className="profileLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Received 𝟐 certificate 𝐑𝐒 𝐒𝐜𝐡𝐨𝐨𝐥
            </a>
            <img
              src="./images/icons/link.png"
              className="linkIcon"
              alt="linkIcon"
            />
          </li>
          <ul>
            <li>
              <a
                href="https://app.rs.school/certificate/ecw26weg"
                className="profileLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                THE ROLLING SCOPES SCHOOL JS/FE PRE-SCHOOL 2022Q2 (JAVASCRIPT)
              </a>
              <img
                src="./images/icons/link.png"
                className="linkIcon"
                alt="linkIcon"
              />
            </li>
            <li>
              <a
                href="https://app.rs.school/certificate/d90px16p"
                className="profileLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                THE ROLLING SCOPES SCHOOL JAVASCRIPT/FRONT- END 2022Q3
                (JAVASCRIPT)
              </a>
              <img
                src="./images/icons/link.png"
                className="linkIcon"
                alt="linkIcon"
              />
            </li>
          </ul>
          <li>
            <a
              href="https://www.freecodecamp.org/"
              className="profileLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Received 4 certificates 𝐟𝐫𝐞𝐞𝐂𝐨𝐝𝐞𝐂𝐚𝐦𝐩
            </a>
            <img
              src="./images/icons/link.png"
              className="linkIcon"
              alt="linkIcon"
            />
          </li>
          <ul>
            <li>
              <a
                href="https://www.freecodecamp.org/certification/lickoneyou/front-end-development-libraries"
                className="profileLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                Front End Development Libraries
              </a>
              <img
                src="./images/icons/link.png"
                className="linkIcon"
                alt="linkIcon"
              />
            </li>
            <li>
              <a
                href="https://www.freecodecamp.org/certification/lickoneyou/javascript-algorithms-and-data-structures"
                className="profileLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                Legacy JavaScript Algorithms and Data Structures Certification
              </a>
              <img
                src="./images/icons/link.png"
                className="linkIcon"
                alt="linkIcon"
              />
            </li>
            <li>
              <a
                href="https://www.freecodecamp.org/certification/lickoneyou/javascript-algorithms-and-data-structures-v8"
                className="profileLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                JavaScript Algorithms and Data Structures (Beta)
              </a>
              <img
                src="./images/icons/link.png"
                className="linkIcon"
                alt="linkIcon"
              />
            </li>
            <li>
              <a
                href="https://www.freecodecamp.org/certification/lickoneyou/responsive-web-design"
                className="profileLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                Responsive Web Design
              </a>
              <img
                src="./images/icons/link.png"
                className="linkIcon"
                alt="linkIcon"
              />
            </li>
          </ul>
          <li>
            <a
              href="https://www.codewars.com/users/lickoneyou"
              className="profileLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Scored 𝟐𝟔𝟎𝟎+ points 𝐂𝐨𝐝𝐞𝐰𝐚𝐫𝐬
            </a>
            <img
              src="./images/icons/link.png"
              className="linkIcon"
              alt="linkIcon"
            />
          </li>
          <li>
            <a
              href="https://github.com/lickoneyou/Courses"
              className="profileLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Completed 𝟏𝟖 courses from 𝐁𝐨𝐠𝐝𝐚𝐧 𝐒𝐭𝐚𝐬𝐡𝐜𝐡𝐮𝐤, 𝐢𝐓𝐆𝐢𝐝, 𝐋𝐨𝐟𝐭𝐬𝐜𝐡𝐨𝐨𝐥,
              𝐏𝐮𝐫𝐩𝐥𝐞𝐒𝐜𝐡𝐨𝐨𝐥 and others
            </a>
            <img
              src="./images/icons/link.png"
              className="linkIcon"
              alt="linkIcon"
            />
          </li>
        </ul>
      </div>
    ),
  },
]

const education = [
  {
    title: 'Belarusian-Russian University',
    specialization: 'Diploma in Taxes and Texation',
    age: '2013 - 2017',
  },
  {
    title: 'Rolling Scopes School',
    specialization: 'JAVASCRIPT/FRONT-END',
    age: '2022 - 2023',
  },
]

const employmentHistory = [
  {
    title: 'Bobruisk Brovar',
    specialization: 'Merchandiser',
    age: '2018',
  },
  {
    title: 'Yandex',
    specialization: 'Geodata specialist',
    age: '2018 - 2019',
  },
  {
    title: 'Raben',
    specialization: 'Warehouse worker ',
    age: '2020',
  },
  {
    title: 'Yandex',
    specialization: 'Support',
    age: '2020 - 2024',
  },
]

const languages = [
  { language: 'Russian', lvl: 'native' },
  { language: 'English', lvl: 'А2' },
]

const skills = [
  [
    './images/tools/js.svg',
    './images/tools/ts.svg',
    './images/tools/react.svg',
    './images/tools/nextjs.svg',
    './images/tools/redux.svg',
    './images/tools/vuejs.svg',
  ],
  [
    './images/tools/html.svg',
    './images/tools/pug.png',
    './images/tools/css.svg',
    './images/tools/sass.svg',
    './images/tools/tailwindcss.svg',
  ],
  [
    './images/tools/jest.svg',
    './images/tools/mocha.svg',
    './images/tools/cypress.svg',
    './images/tools/reacttestignlibrary.png',
    './images/tools/postman.svg',
  ],
  ['./images/tools/php.svg', './images/tools/wordpress.svg'],
  [
    './images/tools/git.svg',
    './images/tools/figma.svg',
    './images/tools/pixso.png',
  ],
]

export { profile, education, employmentHistory, languages, skills }
